import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSquareBehindSquare4"><Path d="M15.25 15.25V19C15.25 20.2426 14.2426 21.25 13 21.25H5C3.75736 21.25 2.75 20.2426 2.75 19V11C2.75 9.75736 3.75736 8.75 5 8.75H8.75M11 15.25H19C20.2426 15.25 21.25 14.2426 21.25 13V5C21.25 3.75736 20.2426 2.75 19 2.75H11C9.75736 2.75 8.75 3.75736 8.75 5V13C8.75 14.2426 9.75736 15.25 11 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSquareBehindSquare4;
